/**
 * Created by Miguel on 23/05/2017
 */
import { Component, HostListener,OnInit, ViewChild,ChangeDetectionStrategy, ViewEncapsulation  } from '@angular/core';
import { ActivatedRoute,RouterLink} from '@angular/router';
import { DomSanitizer,  SafeResourceUrl , SafeHtml } from '@angular/platform-browser';
import { Subscription } from 'rxjs/Subscription';
import { EventBean } from '../../beansts/Event';
import { CompanyService }  from '../../services/company.service';
import { AppDataService }  from '../../services/app-data.service';
import {CompanyBean} from "../../beansts/company.bean";
import {ItemBean} from "../../beansts/item.bean";

import { MessagingService } from "../../messaging.service";
import {Router} from "@angular/router";
import {FormBuilder, FormGroup} from "@angular/forms";
import {TranslationService} from '../../services/translation.service';
import {EventComponent} from './event.component'
import { WalletService }  from '../../services/wallet.services';
import { HttpEventType } from '@angular/common/http';
import { database } from 'firebase';
//teleview
declare var Swal : any;
declare var $ : any;
declare var google : any;
declare var geocoder :any;
@Component({
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.Emulated,
    selector : 'mapEvent',
    templateUrl:'map.event.component.html',
    providers  : []
})
export class MapEventComponent extends EventComponent implements OnInit {
    private _companiesSubscription : Subscription;
    public filter = ""
    public searchForm : FormGroup;
    public event: EventBean=new EventBean();
    public buyerGold=0

    public selectedOption;
    public photo='https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/gameImages%2Fbackgrounds%2Ftela%20fundo%20reuniao.jpeg?alt=media&token=2303f2d4-4b37-4531-aca0-c26b489a5465'
    public muted;

    public door;
    public iframeVolume;
    public queryRoom=null;

    public user={uid:'n/a',full_name:'Anonimo',profile_picture:'nil'};
    public userOnView;
    public openContact=false;
    public chatId;
    public loginTab=false;
    public tables=[];
    public notification;
    public hasTele=false;
    public mytable={};
    public countdown='';

    public zoomControl=0;

    public partyMembersRef;
    public conference=true;
    public loadingConference=false;
    public hasCamera=true;
    public bigConference=false;
    public bigStream=false;
    public videoCall='';

    public admin= false;
    public video='DESLIGAR VIDEO'

    public changed=null;
    public loveList=[];
    public userList=[];
    public enterOrAvatar="ENTRAR"


    public position;
    public mouseDown;
    public mouseUp;

    public toggleCellPhone=false;
    public nameTable=true;
    public chooseFriends=false;

    public language="pt"
    public notificationsON=false;
    public tab=1;

    public canEdit;

    public companyEvents:EventBean [];
    public company:CompanyBean=new CompanyBean();
    public meetingForm

    constructor( public _sanitizer: DomSanitizer,public translate: TranslationService, public _router : Router,public _routeParams : ActivatedRoute,public _companyService : CompanyService,public _walletService : WalletService, public _appData : AppDataService,public msgService: MessagingService, public fb: FormBuilder) {
      super( _sanitizer, translate, _router,_routeParams, _companyService,_walletService,  _appData,msgService,fb)
      this.meetingForm = this.fb.group({
        name : '',
        objective : '',
        locked: '',
      });
    }
    public ngOnDestroy() {

    }

    @HostListener('document:keydown', ['$event'])
    keypress(e: KeyboardEvent) {
      if (e.keyCode == 38) {
        this.zoom(true)
        // up arrow
      }
      else if (e.keyCode == 40) {
          // down arrow
          this.zoom(false)
      }

    }
    public click(item){
      Swal.fire({title:this.translate.instant('PURCHASE_TERRAIN_MODAL_06'),
      text:this.translate.instant('PURCHASE_TERRAIN_MODAL_07'),
      confirmButtonText:this.translate.instant('YES'),
      cancelButtonText:this.translate.instant('CANCEL'),
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false, 
      }).then((result) => {
        if (result.dismiss=='backdrop') {}
        else if (result.dismiss=='close') {}
        else if (result.dismiss=='cancel'){
        }
        else{
          if (item.built){
            if (this._appData.instagramUser.uid<0){
              let domain=window.location.origin
              window.location.href=domain+"/welcome?event="+this._appData.event.id+'&room='+item.room;     
            }
            else{
                let domain=window.location.origin
                window.location.href=domain+"/gameevent/"+this._appData.event.id+"?room="+item.room;       
            }
          }
          else{
            if (this._appData.instagramUser.uid==item.owner){
              let domain=window.location.origin
              window.location.href=domain+"/gameevent/"+this._appData.event.id+"?room="+item.room;       
            }
            else{
              Swal.fire({title:'Terreno em construção',text:'Esse terreno está em construção. Apenas o dono pode lhe convidar para entrar.'})
            }

          }
        }



      });
    }
    public selectChange( $event){
      let i=0;
      this.filter = $('#SelecaoMapa').find(":selected").text();
      this.loveList=[]
      switch (this.filter){
        case 'Pontos turisticos': {
          this._companyService.getMapPointsRef(this._appData.event.id.toString()).where("filter","==","tourism").get().then((v)=>{
            v.forEach(t=>{
              let point=t.data();
              this.loveList.push(point)

            })
          })

          break;
        }
        case 'Lojas': {
          this._companyService.getRooms().where("kind","==","retail").get().then((v)=>{
            v.forEach(t=>{
              let room=t.data();
              this.loveList.push({name:room.roomName,city:'',room:room.id,built:true})

            })
          })

          break;
        }
        case 'Eventos': {
          this._companyService.getMapPointsRef(this._appData.event.id.toString()).where("filter","==","event").get().then((v)=>{
            v.forEach(t=>{
              let point=t.data();
              this.loveList.push(point)

            })
          })


          break;
        }

      }
    }
    public searchNewPoints(map,point){
      // Each item in 'bounds' represents a startAt/endAt pair. We have to issue
      // a separate query for each pair. There can be up to 9 pairs of bounds
      // depending on overlap, but in most cases there are 4.
      let promise= this._companyService.getMapPoints(this._appData.event.id.toString(),point).then(snapshot=>{
        snapshot.docs.forEach(doc=>{
          let dat=doc.data()
          if (dat.owner){
//            var imageBounds = dat.bounds;
            let position=dat.location;
            var imageBounds={
              east:position.longitude+0.0003,
              west:position.longitude-0.0003,
              north:position.latitude+0.0003,
              south:position.latitude-0.0003
            }
            let historicalOverlay = new google.maps.GroundOverlay(
              dat.icon,
              imageBounds
            );
            historicalOverlay.addListener("click",()=>{

              Swal.fire({title:this.translate.instant('PURCHASE_TERRAIN_MODAL_06'),
              text:this.translate.instant('PURCHASE_TERRAIN_MODAL_07'),
              confirmButtonText:this.translate.instant('YES'),
              cancelButtonText:this.translate.instant('CANCEL'),
              showCloseButton: true,
              showCancelButton: true,
              focusConfirm: false, 
              }).then((result) => {
                if (result.dismiss=='backdrop') {}
                else if (result.dismiss=='close') {}
                else if (result.dismiss=='cancel'){
                }
                else{
                  if (dat.built){
                    if (this._appData.instagramUser.uid<0){
                      let domain=window.location.origin
                      window.location.href=domain+"/welcome?event="+this._appData.event.id+'&room='+dat.room;     
                    }
                    else{
                        let domain=window.location.origin
                        window.location.href=domain+"/gameevent/"+this._appData.event.id+"?room="+dat.room;       
                    }
                  }
                  else{
                    if (this._appData.instagramUser.uid==dat.owner){
                      let domain=window.location.origin
                      window.location.href=domain+"/gameevent/"+this._appData.event.id+"?room="+dat.room;       
                    }
                    else{
                      Swal.fire({title:'Terreno em construção',text:'Esse terreno está em construção. Apenas o dono pode lhe convidar para entrar.'})
                    }

                  }
                }


        
              });
            })
            historicalOverlay.setMap(map); 
          }
          else{
            let position=dat.location;
            var imageBounds3={
              east:position.longitude+0.0003,
              west:position.longitude-0.0003,
              north:position.latitude+0.0003,
              south:position.latitude-0.0003
            }
            let historicalOverlay = new google.maps.GroundOverlay(
              dat.icon,
              imageBounds3
            );
            historicalOverlay.addListener("click",()=>{
              if (this._appData.instagramUser.uid<0){
                Swal.fire({title:this.translate.instant('PURCHASE_TERRAIN_MODAL_01'),
                text:this.translate.instant('PURCHASE_TERRAIN_MODAL_05'),
                confirmButtonText:this.translate.instant('DOREGISTER'),
                cancelButtonText:this.translate.instant('CANCEL'),
                showCloseButton: true,
                showCancelButton: true,
                focusConfirm: false, 
                }).then((result) => {
                  if (result.dismiss=='backdrop') {}
                  else if (result.dismiss=='close') {}
                  else if (result.dismiss=='cancel'){
                  }
                  else{
                      $('#registerSocialModal').modal('show')
//                      this._companyService.openExternalLink(item.param.link,true);
                  }
              }); 
                Swal.fire({title:'Você está deslogado.',text:'Apenas usuários logados podem fazer compra de terrenos.'})
              }
              else{
                Swal.fire({title:this.translate.instant('PURCHASE_TERRAIN_MODAL_01'),
                      text:this.translate.instant('PURCHASE_TERRAIN_MODAL_02')+dat.price+this.translate.instant('PURCHASE_TERRAIN_MODAL_03'),
                      confirmButtonText:this.translate.instant('PURCHASE_TERRAIN_MODAL_04'),
                      cancelButtonText:this.translate.instant('CANCEL'),
                      showCloseButton: true,
                      showCancelButton: true,
                      focusConfirm: false, 
                      }).then((result) => {
                        if (result.dismiss=='backdrop') {}
                        else if (result.dismiss=='close') {}
                        else if (result.dismiss=='cancel'){
                        }
                        else{
                            this._appData.param={kind:'purchase',terrain:dat}
                            $('#payTerrainModal').modal('show')
                            $('#payTerrainModalClick').click()

  //                          this._companyService.openExternalLink(item.param.link,true);
                        }
                    });             
              }
        
            });
            historicalOverlay.setMap(map); 
          }
  
        })
      })
    }
    public doSearch(){
      let query : string      = this.searchForm.controls['search'].value;
/*      let geocoder = new google.maps.Geocoder();
      geocoder.geocode( { 'address': query}, function(results, status) {

        if (status == google.maps.GeocoderStatus.OK) {
            var latitude = results[0].geometry.location.latitude;
            var longitude = results[0].geometry.location.longitude;
            alert(latitude);
            } 
        }); */
    }
    public showPosition(position){

      this.position=position;
      setTimeout(()=>{
        this._appData.page='map'
//        const uluru = { lat: this.position.coords.latitude, lng: this.position.coords.longitude };
        const uluru = { lat: -22.966546, lng: -43.176229 };

// The map, centered at Uluru
        const map = new google.maps.Map(
          document.getElementById("map") as HTMLElement,
          {
            zoom: 18,
            center: this.position,
            streetViewControl: false,
            zoomControl: false,
            mapTypeId: "satellite",
          }
        );

        let query=document.getElementById('searchInputMap');
        var autocomplete = new google.maps.places.Autocomplete(query);
        autocomplete.addListener('place_changed', ()=> {
          var place = autocomplete.getPlace();
          let location={lat:place.geometry['location'].lat(), lng:place.geometry['location'].lng()}
          console.log(location)
          this.showPosition(location);
        // place variable will have all the information you are looking for.
        });

       map.addListener("dblclick",(event)=>{
         if (this._appData.edit){
           let position=event.latLng;
           this._appData.param={kind:'editMap',position:position}
           $('#editRoomModal').modal("show");
           $('#editRoomModalClick').click();
         }

        })
      
      
        map.addListener("center_changed", () => {
          if (!this.mouseDown) {
            let center=map.getCenter();
            let pt={lat:center.lat(),lng:center.lng()};
            this.searchNewPoints(map,pt);
              //user has clicked the pan button
          }            
      });
      
      map.addListener("mouseup", function() {
          this.mouseDown = false;
      });
      
      map.addListener("mousedown", function() {
          this.mouseDown = true;
      });
      this.searchNewPoints(map,uluru);





      },2000)

    }
    public getLink(){
      let domain=window.location.origin
      navigator.clipboard.writeText(domain+'/meeting/'+this._appData.event.id+'?room='+this._appData.room.id);
      Swal.fire(this.translate.instant('SUCCESS'),'Link da sala de reunião transferido para memória. Use Ctrl-V para colar o link em conversa com quem você quiser convidar.')
    }
    public ngOnInit() : any {
      super.ngOnInit();  

      
      this.searchForm = this.fb.group({
        search : '',
      });
      if (this._appData.latLng){
        let position=this._appData.latLng
        this.showPosition(position)
      }
      else{
        if (navigator && navigator.geolocation) {
          navigator.geolocation.getCurrentPosition((position)=>{this.showPosition(position)});
        } else {
          
        }  
      }

      
/*
      var markerImage = new google.maps.MarkerImage(
        'https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/gameImages%2Fbuildings%2Fg4801.png?alt=media&token=c3bf9e30-f2d7-4b36-b3a7-00afc6f79a5f',
        new google.maps.Size(8,8), //size
        null, //origin
        null, //anchor
        new google.maps.Size(8,8) //scale
      );
    
        var marker = new google.maps.Marker({
            position: uluru,
            map: map,
            icon: markerImage //set the markers icon to the MarkerImage
        });
    
    //when the map zoom changes, resize the icon based on the zoom level so the marker covers the same geographic area
    google.maps.event.addListener(map, 'zoom_changed', function() {
    
        var pixelSizeAtZoom0 = 8; //the size of the icon at zoom level 0
        var maxPixelSize = 350; //restricts the maximum size of the icon, otherwise the browser will choke at higher zoom levels trying to scale an image to millions of pixels
    
        var zoom = map.getZoom();
        var relativePixelSize = Math.round(pixelSizeAtZoom0*Math.pow(2,zoom)); // use 2 to the power of current zoom to calculate relative pixel size.  Base of exponent is 2 because relative size should double every time you zoom in
    
        if(relativePixelSize > maxPixelSize) //restrict the maximum size of the icon
            relativePixelSize = maxPixelSize;
    
        //change the size of the icon
        marker.setIcon(
            new google.maps.MarkerImage(
                marker.getIcon().url, //marker's same icon graphic
                null,//size
                null,//origin
                null, //anchor
                new google.maps.Size(relativePixelSize, relativePixelSize) //changes the scale
            )
        );        
    });
*/

  }


  public onChangeForm(){
    this.meetingForm = this.fb.group({
      name :  this._appData.room.meetingName,
      objective : this._appData.room.meetingObjective,
      locked: this._appData.room.locked,
    });
  }

  public changeRoom(){
    let date=new Date();
    let time=date.getTime();
    let name=this.meetingForm.controls['name'].value;
    let objective=this.meetingForm.controls['objective'].value;
    let lock=this.meetingForm.controls['locked'].value;
    if (!lock) lock=false;
    let notification={
      event:this._appData.event.id,
      time:time,
      senderUid:this._appData.instagramUser.uid,
      senderName:name,
      senderThumbnail:'',
      subject:name,
      message:objective,
      kind:'roomChange',
      link:lock,
      read:false,
      action:'',
      answer:''
    }
    this._companyService.addRoomNotification(this._appData.room,notification)
    Swal.fire({title:'Mudanças feitas',text:'Atualizados dados da sala'})
  }
  private lockedRoomControl(){


   // if (this._appData.instagramUser.uid>0){
      if (this._appData.userEventContainer){
        this.popUpLockedRoom();
      }
      else{
        this._companyService.getUserContainerRef().get().then(cdata=>{
          let clist=[];
  
          cdata.forEach(c=>{
            let item=new ItemBean();
            item.parse(c.data())
            clist.push(item)
          })
          this._appData.userEventContainer=clist;
          this.popUpLockedRoom();
        })
      }

  }
  public popUpLockedRoom(){
    let key=this._appData.room.key;
    let hasKey=this.checkKey(key);
 
    
      if (!this._appData.instagramUser.full_name){
        Swal.fire({title:"Sala trancada",
          text: 'Esta sala de reuniões está trancada. Por favor escreva o seu nome e clique ok para pedir autorização aos presentes na sala para entrar.',
          input: 'text',
          inputAttributes: {
            autocapitalize: 'off'
          },
          showCancelButton: true,
          confirmButtonText: 'Salvar',
          showLoaderOnConfirm: true,
          preConfirm: (name) => {
            let date=new Date();
            let time=date.getTime();
            let notification={
              event:this._appData.event.id,
              time:time,
              senderUid:this._appData.instagramUser.uid,
              senderName:name,
              senderThumbnail:'',
              subject:'Knock Knock',
              message:name+' deseja entrar na sala. Você permite ele entrar?',
              kind:'enterRoom',
              link:'',
              read:false,
              action:'',
              answer:''
            }
            this._companyService.addRoomNotification(this._appData.room,notification)
          }
        })
      }
      else if (hasKey){
        Swal.fire({title:"Sala trancada",
          text: 'Esta sala de reuniões está trancada. Você possui a chave...deseja entrar de qualquer forma?',
          showCancelButton: true,
          confirmButtonText: 'ENTRAR',
          showLoaderOnConfirm: true,
          preConfirm: (name) => {
            if (name){
              $("#jitsiReload").click();   
              this.canEdit=true;
            }
          }
        })
      }
      else{
        var swalObj={
          title: "Sala trancada",
          showCloseButton: true,
          text: "Esta sala de reuniões está trancada. Você deseja pedir autorização aos presentes na sala para entrar?",
          showConfirmButton:true,
          confirmButtonText:this.translate.instant('YES')
        }
        Swal.fire(swalObj).then( (resultok) =>{
            if (resultok.value) {
              let name=this._appData.instagramUser.full_name
              let date=new Date();
              let time=date.getTime();
              let notification={
                event:this._appData.event.id,
                time:time,
                senderUid:this._appData.instagramUser.uid,
                senderName:name,
                senderThumbnail:'',
                subject:'Knock Knock',
                message:name+' deseja entrar na sala. Você permite ele entrar?',
                kind:'enterRoom',
                link:'',
                read:false,
                action:'',
                answer:''
              }
            this._companyService.addRoomNotification(this._appData.room,notification)
            }
        });         
      }




  }


  private logUserToRoom(){

          if (this._appData.room.locked){
            this.lockedRoomControl()
          }
          else{
            this.addToParty();
            $("#jitsiReload").click();   
            this.canEdit=true;          }
         

    }

    public notifyRegister(){
      let date=new Date();
      let time=date.getTime();
      let name=this._appData.instagramUser.full_name;
      let notification={
        event:this._appData.event.id,
        time:time,
        senderUid:this._appData.instagramUser.uid,
        senderName:name,
        senderThumbnail:'',
        subject:'Pedido de cadastro',
        message:'Você deseja se cadastar?',
        kind:'registerNotification',
        link:'',
        read:false,
        action:'',
        answer:''
      }
      this._companyService.addRoomNotification(this._appData.room,notification) 
    }
    public notifyAvatar(){
      let date=new Date();
      let time=date.getTime();
      let name=this._appData.instagramUser.full_name;
      let notification={
        event:this._appData.event.id,
        time:time,
        senderUid:this._appData.instagramUser.uid,
        senderName:name,
        senderThumbnail:'',
        subject:'Mudar Avatar',
        message:'Você deseja mudar seu avatar?',
        kind:'avatarChange',
        link:'',
        read:false,
        action:'',
        answer:''
      }
      this._companyService.addRoomNotification(this._appData.room,notification)   
    }
    public cameraFix(){
      let date=new Date();
      let time=date.getTime();
      let name=this._appData.instagramUser.full_name;
      let notification={
        event:this._appData.event.id,
        time:time,
        senderUid:this._appData.instagramUser.uid,
        senderName:name,
        senderThumbnail:'',
        subject:'Pedido de fix camera',
        message:'Pede para voce autorizar mudar a camera',
        kind:'cameraFix',
        link:'',
        read:false,
        action:'',
        answer:''
      }
      this._companyService.addRoomNotification(this._appData.room,notification) 
    }

    public checkKey(needKey){
      if (needKey==this._appData.instagramUser.uid){
        return true;
      }
      else{
        let filtered=this._appData.userEventContainer.filter(val=>{
          return val.name==needKey                 
        })
        if (filtered[0]){
          return true;
        } 
      }
      return false;
    }
    private checkCookie(){
      var cookieEnabled = navigator.cookieEnabled;
      if (!cookieEnabled){ 
          document.cookie = "testcookie";
          cookieEnabled = document.cookie.indexOf("testcookie")!=-1;
      }
      return cookieEnabled || this.showCookieFail();
    }
  
    public toggleLoginTab(tab){
      if (!this._appData.instagramUser){
        this.loginTab=tab;
      }
    }
    private showCookieFail(){
    // do something here
    Swal.fire('Browser sem cookies','Precisamos que você habilite os cookies para podermos fazer o cadastro na lista')
    return false;
    }


    public gotoCell(){
      if (isNaN(this._appData.instagramUser.uid)){
        this._appData.toggleCellPhone=!this._appData.toggleCellPhone;
      }
      else{
        $('#registerSocialModal').modal("show"); 
      }

    }


public enter(){
  if (!this._appData.instagramUser){
    if (this.event.private){
      $('#registerSocialModal').modal("show"); 
    }
    else{
      $('#privatePartyModal').modal("show"); 
    }
  }
}

public getImageNoDraw(imgRef) {
  if (this._appData.images[imgRef])
      return this._appData.images[imgRef];
  else {
      // Load image if not in cache
      var img = new Image();
      img.src = imgRef;
      img.onload = ()=>{
        this._appData.images[imgRef].loaded=true;
      }
      this._appData.images[imgRef] = img;
      return img;
  }
}


    public gotoMyData(){
      $('#jitsi-control-tutorial').click();

      $('#updateMeModal').modal('hide');
      this._router.navigate(['/userprofile'])
      this._companyService.getUserContainer(true)
    }





  public zoom(inout){



    if (inout){
//      if (this.zoomControl<20){
        this.zoomControl=this.zoomControl+1;
        this.sendIframeMessage({kind:'zoomout'})
        $("#btnZoomIn").attr("src", "./assets/game-ui/desk/g6501.png");
        setTimeout(()=>{
          $("#btnZoomIn").attr("src", "./assets/game-ui/desk/g4421.png");
        },1000);
  //    }
    }
    else{
    //  if (this.zoomControl>-8){
        this.zoomControl=this.zoomControl-1;
        this.sendIframeMessage({kind:'zoomin'})
        $("#btnZoomOut").attr("src", "./assets/game-ui/desk/g6631.png");
        setTimeout(()=>{
          $("#btnZoomOut").attr("src", "./assets/game-ui/desk/g4415.png");
        },1000);
  
      //}
      

    }
  }
  public sendIframeMessage(messageKind){
      var iframe = document.getElementById('gameFrame');
      if (iframe == null) return;
      var iWindow = (<HTMLIFrameElement>iframe).contentWindow;
      iWindow.postMessage(messageKind, "*");
  }



  public leave(){
    if (this._appData.room.id.indexOf('noroom')<0){
      this._companyService.getRoom(this._appData.room.id).update({meeting:true});
    }
    Swal.fire({
      title: 'Sair',
      message:' Você deseja sair desta reunião?',
      confirmButtonText: 'Sair',
      cancelButtonText:"Ficar",
      showCancelButton: true,
      focusConfirm: false,}).then((result) => {
        if (result.dismiss=='backdrop') {}
        else if (result.dismiss=='cancel'){
          //sair
        }
        else if (result.value) {
          //entrar
          //entrar
          let keys=Object.keys(this._appData.userLookup).length
          let domain=window.location.origin
          if (keys<=1){
            this._appData.userLookup={}
            this._companyService.updateConferenceUsers(this._appData.room).set(this._appData.userLookup).then(()=>{
              window.location.href = domain+"/gameevent/"+this._appData.event.id+"?room="+this._appData.room.father;
            })
          }
          else{
            window.location.href = domain+"/gameevent/"+this._appData.event.id+"?room="+this._appData.room.father;
          }
        }
      })

  }
  public addItem(){

    let livecoin=this.buyerGold;
    let date=new Date();
    let milis=date.getTime()
    Swal.fire({
      title: 'Que item deseja comprar?',
      html: "<img id='postitImg"+milis+"' src='/assets/game-ui/desk/g31611.png' style='width:50px;height:50px'><img id='docs"+milis+"' src='/assets/game-ui/desk/g31611B.png' style='width:50px;height:50px;margin-left:5px'><img id='excel"+milis+"'  src='/assets/game-ui/desk/g31611C.png' style='width:50px;height:50px;margin-left:5px'><img id='powerpoint"+milis+"' src='/assets/game-ui/desk/g31611D.png' style='width:50px;height:50px;margin-left:5px'><img id='draw"+milis+"' src='/assets/game-ui/desk/g31611E.png' style='width:50px;height:50px;margin-left:5px'>",
      showConfirmButton: false,
      showCancelButton: false,     
    })
    $(document).on('click', '#postitImg'+milis, ()=> {
      let cost=1;
      if (livecoin>cost){
        Swal.fire({
          title:'Comprar Postits',
          text:'Os postits servem para você conectar qualquer link externo e compartilhar com pessoas. Cada 10 postits custam 1 LiveCoin. Você possui '+livecoin+' livecoins em sua wallet. Deseja comprar os 10 postits?',     
          confirmButtonText: "Sim",
          cancelButtonText:"Não",
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false, 
          }).then((result) => {
            if (result.dismiss=='backdrop') {}
            else if (result.dismiss=='close') {}
            else if (result.dismiss=='cancel'){}
            else{
              this.makePostIt();
            }           
        }) 
      }
      else{
        Swal.fire({
          title:'Comprar Postits',
          text:'Os postits servem para você conectar qualquer link externo e compartilhar com pessoas. Cada 10 postits custam 1 LiveCoin. Você possui '+livecoin+' livecoins em sua wallet. Você deseja comprar mais LiveCoins?',     
          confirmButtonText: "Sim",
          cancelButtonText:"Não",
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false, 
          }).then((result) => {
            if (result.dismiss=='backdrop') {}
            else if (result.dismiss=='close') {}
            else if (result.dismiss=='cancel'){}
            else{
              Swal.fire({title:'Aguarde',text:'Essa função está em desenvolvimento. Em breve você poderá comprar livecoins aqui.'})
            }           
        }) 
      }

    }); 
    $(document).on('click', '#docs'+milis, ()=> {
      //1639442415373 livro
      let cost=1;
      if (livecoin>cost){
        Swal.fire({
          title:'Comprar Livro',
          text:'O Livro é um documento do tipo GOOGLE DOC preparado para uso. Você pode escrever e compartilhar com pessoas. Cada livro custa 1 LiveCoin. Você possui '+livecoin+' livecoins em sua wallet. Deseja comprar os 1 livro?',     
          confirmButtonText: "Sim",
          cancelButtonText:"Não",
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false, 
          }).then((result) => {
            if (result.dismiss=='backdrop') {}
            else if (result.dismiss=='close') {}
            else if (result.dismiss=='cancel'){}
            else{
              this.makeItem('application/vnd.google-apps.document','1639442415373')
            }           
        }) 
      }
      else{
        Swal.fire({
          title:'Comprar Livro',
          text:'O Livro é um documento do tipo GOOGLE DOC preparado para uso. Você pode escrever e compartilhar com pessoas. Cada livro custa 1 LiveCoin. Você possui '+livecoin+' livecoins em sua wallet. Deseja adquirir mais livecoins?',     
          confirmButtonText: "Sim",
          cancelButtonText:"Não",
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false, 
          }).then((result) => {
            if (result.dismiss=='backdrop') {}
            else if (result.dismiss=='close') {}
            else if (result.dismiss=='cancel'){}
            else{
              Swal.fire({title:'Aguarde',text:'Essa função está em desenvolvimento. Em breve você poderá comprar livecoins aqui.'})
            }           
        }) 
      }

    }); 
    $(document).on('click', '#excel'+milis, ()=> {
      //1639448112414 excel
      let cost=1;
      if (livecoin>cost){
        Swal.fire({
          title:'Comprar Calculadora',
          text:'A calculadora é um documento do tipo GOOGLE EXCEL preparado para uso. Você pode escrever e compartilhar com pessoas. Cada calculadora custa 1 LiveCoin. Você possui '+livecoin+' livecoins em sua wallet. Deseja comprar os 1 calculadora?',     
          confirmButtonText: "Sim",
          cancelButtonText:"Não",
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false, 
          }).then((result) => {
            if (result.dismiss=='backdrop') {}
            else if (result.dismiss=='close') {}
            else if (result.dismiss=='cancel'){}
            else{
              this.makeItem('application/vnd.google-apps.spreadsheet','1639448112414')
            }           
        }) 
      }
      else{
        Swal.fire({
          title:'Comprar Calculadora',
          text:'A calculadora é um documento do tipo GOOGLE EXCEL preparado para uso. Você pode escrever e compartilhar com pessoas. Cada calculadora custa 1 LiveCoin. Você possui '+livecoin+' livecoins em sua wallet. Deseja comprar LIVECOINS?',     
          confirmButtonText: "Sim",
          cancelButtonText:"Não",
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false, 
          }).then((result) => {
            if (result.dismiss=='backdrop') {}
            else if (result.dismiss=='close') {}
            else if (result.dismiss=='cancel'){}
            else{
              Swal.fire({title:'Aguarde',text:'Essa função está em desenvolvimento. Em breve você poderá comprar livecoins aqui.'})
            }           
        })
      } 
    }); 
    $(document).on('click', '#powerpoint'+milis, ()=> {
      //1639448539824 cavelete
      let cost=1;
      if (livecoin>cost){
        Swal.fire({
          title:'Comprar Cavalete',
          text:'O Cavalete é um documento do tipo GOOGLE POWERPOINT preparado para uso. Você pode escrever e compartilhar com pessoas. Cada cavalete custa 1 LiveCoin. Você possui '+livecoin+' livecoins em sua wallet. Deseja comprar o cavalete?',     
          confirmButtonText: "Sim",
          cancelButtonText:"Não",
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false, 
          }).then((result) => {
            if (result.dismiss=='backdrop') {}
            else if (result.dismiss=='close') {}
            else if (result.dismiss=='cancel'){}
            else{
              this.makeItem('application/vnd.google-apps.presentation','1639448539824')
            }           
        }) 
      }
      else{
        Swal.fire({
          title:'Comprar Cavalete',
          text:'O Cavalete é um documento do tipo GOOGLE POWERPOINT preparado para uso. Você pode escrever e compartilhar com pessoas. Cada cavalete custa 1 LiveCoin. Você possui '+livecoin+' livecoins em sua wallet. Deseja comprar LIVECOINS?',     
          confirmButtonText: "Sim",
          cancelButtonText:"Não",
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false, 
          }).then((result) => {
            if (result.dismiss=='backdrop') {}
            else if (result.dismiss=='close') {}
            else if (result.dismiss=='cancel'){}
            else{
              Swal.fire({title:'Aguarde',text:'Essa função está em desenvolvimento. Em breve você poderá comprar livecoins aqui.'})
            }           
        })
      }       
    }); 
    $(document).on('click', '#draw'+milis, ()=> {
      //1639448539824 cavelete
            //1639448112414 excel
            let cost=1;
            if (livecoin>cost){
              Swal.fire({
                title:'Comprar Cavalete',
                text:'O Cavalete é um documento do tipo GOOGLE DESENHO preparado para uso. Você pode desenhar e compartilhar com pessoas. Cada cavalete custa 1 LiveCoin. Você possui '+livecoin+' livecoins em sua wallet. Deseja comprar o cavalete?',     
                confirmButtonText: "Sim",
                cancelButtonText:"Não",
                showCloseButton: true,
                showCancelButton: true,
                focusConfirm: false, 
                }).then((result) => {
                  if (result.dismiss=='backdrop') {}
                  else if (result.dismiss=='close') {}
                  else if (result.dismiss=='cancel'){}
                  else{
                    this.makeItem('application/vnd.google-apps.drawing','1639448539824')
                  }           
              }) 
            }
            else{
              Swal.fire({
                title:'Comprar Cavalete',
                text:'O Cavalete é um documento do tipo GOOGLE DESENHO preparado para uso. Você pode desenhar e compartilhar com pessoas. Cada cavalete custa 1 LiveCoin. Você possui '+livecoin+' livecoins em sua wallet. Deseja comprar LIVECOINS?',     
                confirmButtonText: "Sim",
                cancelButtonText:"Não",
                showCloseButton: true,
                showCancelButton: true,
                focusConfirm: false, 
                }).then((result) => {
                  if (result.dismiss=='backdrop') {}
                  else if (result.dismiss=='close') {}
                  else if (result.dismiss=='cancel'){}
                  else{
                    Swal.fire({title:'Aguarde',text:'Essa função está em desenvolvimento. Em breve você poderá comprar livecoins aqui.'})
                  }           
              })
            }       
      
    }); 


        


  }
  public makePostIt(){
    let date=new Date();
    let milis=date.getTime()
    let vet=this._appData.eventRecipes.filter(v=>{
      return v.id=='POSTIT'
    })
    let rec=vet[0]
    let baseItem=rec.toItem()
    baseItem.objectId=milis.toString();
    baseItem.position.x=10
    baseItem.position.y=10
    baseItem.position.z=0
    Swal.fire({
      title: 'Transferindo',
      text: 'Aguarde enquanto a receita do item esta sendo criada',
      imageUrl: "https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/gameImages%2Ftransfer.gif?alt=media&token=67c0bdef-76b4-40e5-8fdb-65501ef94aff",
      showConfirmButton: false
    })
    this._walletService.makePurchaseTransfer(this._appData.event.id,'event',this._appData.instagramUser.uid,'user',rec.tokenId,10,baseItem.toDB(),null,null,this._appData.instagramUser.uid,'user-container',1).subscribe(wa=>{
      Swal.close()
      this._companyService.getUserContainer(true);
      Swal.fire(this.translate.instant('SUCCESS'),'Seus items foram criados e estão disponíveis para uso na sua mochila')
    },err=>{
      Swal.close()
      Swal.fire(this.translate.instant('FAIL'),'Ouve uma falha na criação do token para sua carteira. Tente de novo')

    }) 
  }
  public makeItem(type,recipeId){
          //entrar
          Swal.fire({
            title: 'Selecione o nome do arquivo',
            input: 'text',
            inputAttributes: {
              autocapitalize: 'off'
            },
            showCancelButton: true,
            confirmButtonText: 'Salvar',
            showLoaderOnConfirm: true,
            preConfirm: (login) => {
              if (!login){
                Swal.fire('Erro..','Selecione um nome pro arquivo')
              }
              else{
                let fileName=login;
                Swal.fire({
                  title: 'Criando seu arquivo',
                  html: 'Estamos criando seu arquivo. Isso pode demorar um pouco então por favor pedimos que você aguarde com o browser ligado. Ao final do processo o seu arquivo vai aparecer na área de trabalho.',
                })
                let vet=this._appData.eventRecipes.filter(v=>{
                  return v.id==recipeId
                })
                let rec=vet[0]
                let baseItem=rec.toItem()
                baseItem.name=fileName;
                baseItem.position.x=10
                baseItem.position.y=10
                baseItem.position.z=0
                Swal.fire({
                  title: 'Transferindo',
                  text: 'Aguarde enquanto a receita do item esta sendo criada',
                  imageUrl: "https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/gameImages%2Ftransfer.gif?alt=media&token=67c0bdef-76b4-40e5-8fdb-65501ef94aff",
                  showConfirmButton: false
                })
                this._walletService.makePurchaseTransfer(this._appData.event.id,'event',this._appData.instagramUser.uid,'user',rec.tokenId,1,baseItem.toDB(),null,null,this._appData.instagramUser.uid,'user-container',1).subscribe(wa=>{
                  this._companyService.addNewFileToDrive(this._appData.instagramUser.uid,type,fileName).then(
                    (val)=>{
                      baseItem['param']={link:val,name:fileName},
                      this._companyService.getUserContainerRef().doc(baseItem.objectId).set(baseItem.toDB()).then(val=>{
                        Swal.close()
                        this._appData.userEventContainer.push(baseItem);
                        Swal.fire(this.translate.instant('SUCCESS'),'Seu item foi criado e está disponível para uso em sua mochila')
                      }); 

                  }); 
                },err=>{
                  Swal.close()
                  Swal.fire(this.translate.instant('FAIL'),'Ouve uma falha na criação do token para sua carteira. Tente de novo')

                })
    
              }
            }
          })
  }
  public gotoBag(){
   // if (isNaN(this._appData.instagramUser.uid)){
      this._appData.object=null;
      $('#jitsi-control-tutorial').click();
      $('#containerModal').modal('show')
      $('#containerModal').draggable({
        handle: ".modal-header"
      });
      $('#containerModalClick').click(); 
  //  }
//    else{
   //   Swal.fire('Você está deslogado','Você precisa estar logado para acessar sua mochila.')
 //   }
  }
  public openVideoConf(){
    this.sendIframeMessage({
      kind:'toggleJitsi',
      params:true
    });      
    this._appData.jitsiOn=true;   
    $("#media-control").css("visibility", "hidden");
    $("#youtubeScreen").css("left", "200vw");
    $("#media-control-mobile").css("visibility", "hidden");
    $("#youtubeMobileScreen").css("left", "200vw");      
    $("#videoMobileImage").css('visibility','hidden');
    $("#videoMobileImage2").css('visibility','hidden');
    $("#videoMobileImage3").css('visibility','hidden');
    $("#videoImage1").css('visibility','hidden');
    $("#videoImage2").css('visibility','hidden');
    $("#videoImage3").css('visibility','hidden');
    $("#videoImage4").css('visibility','hidden');

  }
  public openContacts(){


    
    $('#jitsi-control-tutorial').click();
    if (isNaN(this._appData.instagramUser.uid)){
      let idx=$("#profileModal")
      idx.modal('show');
    }
    else{
      $('#registerSocialModal').modal('show')
    }
  }

  public closeModal(name){
    $('#'+name).modal('hide');
    this.nameTable=false;
    this.chooseFriends=false;

  }






  public camera(on: boolean){
        this.videoCall=null;
        if (on != this._appData.conference){
          this.conference=on;
          this._appData.conference=this.conference;
          $('#jitsiReload').click()
          
          $("#chatReload").click();   
          if (!this.conference){
            Swal.fire({title:this.translate.instant('NO_CAMERA_TITLE'),text:this.translate.instant('NO_CAMERA_DESCRIPTION')})
          }
  
        }
  }








}





// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/map.event.component.ts